import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c0b5aac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "w-full mb-15 md:mb-30" }
const _hoisted_3 = { class: "mb-15 md:mb-30" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "md:border-b w-full py-15 lowercase md:flex md:justify-between md:items-center" }
const _hoisted_7 = {
  key: 0,
  class: "border-b pb-10 mb-20 md:py-8 md:mb-0 md:border-0"
}
const _hoisted_8 = { class: "w-full md:ml-auto md:w-auto md:flex md:flex-col md:justify-between md:h-full" }
const _hoisted_9 = { class: "bg-wild-sand mt-40 py-40" }
const _hoisted_10 = { class: "block" }
const _hoisted_11 = { class: "block" }

import { Component, computed, ComputedRef, onUnmounted, watch } from 'vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import StoreDetail from '@/b2c/shared/stores/ui/StoreDetail.vue';
import pageStore from '@/shared/content/page.store';
import offersStore from '@/b2c/offers/offers.store';
import { useRouteQuery } from '@/core/browser/route-query.composable';
import { QueryKeys } from '@/shared/config/route-query.config';
import {
    PersonalOfferBaseItemModel, PersonalOfferDiscountType,
    PersonalOfferItemType, PersonalOfferModuleSofaItemModel, PersonalOfferRegularItemModel,
    PersonalOfferViewModel,
} from '@/b2c/shared/api/server-apis';
import utils from '@/shared/utilities.service';
import RegularItem from '@/b2c/offers/ui/RegularItem.vue';
import ModuleSofaItem from '@/b2c/offers/ui/ModuleSofaItem.vue';
import AddOfferToBasket from '@/b2c/offers/ui/AddOfferToBasket.vue';
import BlockMaxWidthHandler from '@/shared/content/blocks/helpers/BlockMaxWidthHandler.vue';
import OfferSummaryDefault from '@/b2c/offers/ui/helpers/OfferSummaryDefault.vue';
import OfferSummaryMyBoliaBoost from '@/b2c/offers/ui/helpers/OfferSummaryMyBoliaBoost.vue';
import { router } from '@/core/router';
import siteContextStore from '@/shared/content/site-context.store';


export default /*#__PURE__*/_defineComponent({
  __name: 'Offer',
  setup(__props) {

const labels = useBlockLabels();
const id = useRouteQuery<string>(QueryKeys.Id);
const addToBasket = useRouteQuery<boolean>(QueryKeys.AddToBasket);

const offer: ComputedRef<PersonalOfferViewModel> = computed(() => {
    return offersStore.detail;
});

const getOfferItemComponentByType = (type: PersonalOfferItemType): Component => {
    switch (type) {
    case PersonalOfferItemType.Regular:
        return RegularItem;
    case PersonalOfferItemType.ModuleSofa:
        return ModuleSofaItem;
    }
};

const date: ComputedRef<string> = computed(() => {
    return offer.value.createdDate ? utils.formatDate(offer.value.createdDate) : '';
});

const expirationDate: ComputedRef<string> = computed(() => {
    return offer.value.earliestDiscountDate ? utils.formatDate(offer.value.earliestDiscountDate) : '';
});

const showExpirationDate: ComputedRef<boolean> = computed(() => {
    return offersStore.getShowDiscountCountdown(offer.value.earliestDiscountDays);
});

const isPurchasable: ComputedRef<boolean> = computed(() => {
    const discontinued = offer.value.items.find((item: PersonalOfferBaseItemModel) => {
        if (item.type === PersonalOfferItemType.Regular) {
            return (item as PersonalOfferRegularItemModel).variant?.isDiscontinued;
        } else {
            const modules = (item as PersonalOfferModuleSofaItemModel)?.modules ?? [];
            return modules.find((module: PersonalOfferRegularItemModel) => (module as PersonalOfferRegularItemModel).variant?.isDiscontinued) !== undefined;
        }
    });
    return !discontinued;
});

const updatePageAltTitle = (): void => {
    pageStore.setAltTitle(date.value);
};

const updateDetails = async(): Promise<void> => {
    await offersStore.updateDetails(id.value);
    updatePageAltTitle();
};

const hasMyBoliaBoostDiscount = computed(() => {
    return !!offer.value.items.find((item) => item.price.discounts?.find((discount) => discount.type === PersonalOfferDiscountType.MyBoliaBoost));
});

watch(() => id, async() => {
    if (id.value) {
        await updateDetails();

        if (addToBasket.value) {
            try {
                await offersStore.addToBasket();
                router.replace(siteContextStore.settings.basketPageUrl);
            } catch (error) {
                console.error(error);
            }
        }
    }
}, { immediate: true });

onUnmounted(() => {
    offersStore.clearDetail();
    pageStore.clearAltTitle();
});

return (_ctx: any,_cache: any) => {
  return (_unref(offer).offerId)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(BlockMaxWidthHandler, null, {
          default: _withCtx(() => [
            _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$dictionary.format(_unref(labels).title, [_unref(date)])), 1),
            _createElementVNode("div", _hoisted_3, [
              (_unref(showExpirationDate))
                ? (_openBlock(), _createElementBlock("div", {
                    key: "showExpirationDate",
                    innerHTML: _ctx.$dictionary.formatNamed(_unref(offer).earliestDiscountDays === 0 ? _unref(labels).offerWithDiscountDescriptionTodayContent : _unref(labels).offerWithDiscountDescriptionContent, {offerId:_unref(offer).offerId, expirationDate: _unref(expirationDate), daysToExpirationDate: _unref(offer).earliestDiscountDays})
                  }, null, 8, _hoisted_4))
                : (_openBlock(), _createElementBlock("div", {
                    key: "dontShowExpirationDate",
                    innerHTML: _ctx.$dictionary.formatNamed(_unref(labels).offerDescriptionContent, {offerId:_unref(offer).offerId})
                  }, null, 8, _hoisted_5))
            ]),
            _createElementVNode("div", _hoisted_6, [
              (_unref(offer).items.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$dictionary.format(_unref(labels).itemsInList, [_unref(offer).items.length])), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_8, [
                (_unref(isPurchasable))
                  ? (_openBlock(), _createBlock(AddOfferToBasket, {
                      key: 0,
                      "button-text": _unref(labels).addAllItemsToBasketButtonText,
                      class: "w-full md:min-w-350"
                    }, null, 8, ["button-text"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(offer).items, (item) => {
              return (_openBlock(), _createBlock(_resolveDynamicComponent(getOfferItemComponentByType(item.type)), {
                key: item.id,
                item: item
              }, null, 8, ["item"]))
            }), 128))
          ]),
          _: 1
        }),
        _createElementVNode("footer", _hoisted_9, [
          _createVNode(BlockMaxWidthHandler, { class: "summary flex flex-col items-end justify-end" }, {
            default: _withCtx(() => [
              (_unref(hasMyBoliaBoostDiscount))
                ? (_openBlock(), _createBlock(OfferSummaryMyBoliaBoost, { key: 0 }))
                : (_openBlock(), _createBlock(OfferSummaryDefault, { key: 1 }))
            ]),
            _: 1
          })
        ]),
        (_unref(offer).store?.storeId)
          ? (_openBlock(), _createBlock(BlockMaxWidthHandler, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(StoreDetail, {
                  id: _unref(offer).store.storeId,
                  heading: _unref(labels).storeInfoTitle,
                  class: "mt-40"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(offer).store.employeeName), 1),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(labels).storeInfoSalesPerson), 1)
                  ]),
                  _: 1
                }, 8, ["id", "heading"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})